module.exports = __webpack_public_path__ + "static/media/webdesign-services-img59.a377fcbc.jpg";